import { useEffect } from 'react';
import findLast from 'lodash/findLast';
import last from 'lodash/last';
import type { DateRange } from '../../common/types.tsx';
import { pickDateRange } from '../../common/utils/date-range.tsx';
import type { actions } from '../../controllers/selected-date-range/index.tsx';
import type { BarChartData } from '../../services/historical-cycle-time/types.tsx';
import { getSelectedBarChartBarDataAndItsIndex } from '../../services/historical-cycle-time/utils.tsx';

export const useSmartDateRangeSelect = (
	data: BarChartData | null | undefined,
	selectedDateRange: DateRange | null,
	setSelectedRange: typeof actions.setSelectedRange,
) => {
	useEffect(() => {
		if (data != null) {
			const selectLatestWeekWithData = () => {
				const selectedBarData = findLast(
					data.barData,
					(x) => x.cycleTimeStatistics !== null && x.cycleTimeStatistics > 0,
				);
				// @ts-expect-error - TS2345 - Argument of type 'BarChartBarData | undefined' is not assignable to parameter of type 'DateRange'.
				setSelectedRange(pickDateRange(selectedBarData ?? last(data.barData)));
			};

			// For the initial load, find the latest week with some data
			if (selectedDateRange === null) {
				selectLatestWeekWithData();
			}

			// For the data change after the initial load, find the latest week with some data only if currently selected week has no data
			if (
				selectedDateRange !== null &&
				getSelectedBarChartBarDataAndItsIndex(data.barData, selectedDateRange).barData
					.cycleTimeStatistics === 0
			) {
				selectLatestWeekWithData();
			}
		}
	}, [data, selectedDateRange, setSelectedRange]);
};
